// Helper hack to fix an issue from the BE where various user names are
// being saved with an extra space and then returning the project name
// in the form of: "Jane 's Office" which should return as "Jane's Office"
var trimProjectName = function trimProjectName(str) {
  return str ? str.replace(' \'s', '\'s') : '';
};
/**
 * Various client device type queries.
 * These should only be executed client side.
 */


function isiOS() {
  return /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
}

function isChromeiOS() {
  return /CriOS/i.test(navigator.userAgent);
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

function isIPad() {
  return /iPad/i.test(navigator.userAgent);
}
/**
 * Returns whether or not the device has WebGL support.
 * Should only be run client side.
 */


function isWebGLSupported() {
  var canvas;
  var supported;

  try {
    canvas = document.createElement('canvas');
    supported = !!window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'));

    if (supported) {
      supported = true;
    }
  } catch (e) {
    supported = false;
  }

  if (!supported) {
    console.error('WebGL is not supported');
  }

  canvas = undefined;
  return supported;
}
/**
 * Returns whether or not the device has WebGL2 support.
 * Should only be run client side.
 */


function isWebGL2Supported() {
  var canvas;
  var supported;

  try {
    canvas = document.createElement('canvas');
    supported = !!(window.WebGL2RenderingContext && canvas.getContext('webgl2'));
  } catch (e) {
    supported = false;
  }

  if (!supported) {
    console.error('WebGL2 is not supported on this device');
  }

  canvas = undefined;
  return supported;
}
/**
 * Requests device orientation permission for iOS 13+
 * returns a promise that responds with the permission state
 * or false if the device is non iOS 13+
 * NOTE: this is required for the deviceorientation event to work on iOS 13+
 * AND must be called from a user-driven event like a button click
 */


function requestDeviceOrientationPermission() {
  // DeviceOrientationEvent doesn't exist for safari
  // eslint-disable-next-line
  if (!window.DeviceOrientationEvent) return Promise.resolve('granted'); // eslint-disable-next-line

  if (isMobileDevice() && typeof DeviceOrientationEvent.requestPermission === 'function') {
    // eslint-disable-next-line
    return DeviceOrientationEvent.requestPermission().then(function (response) {
      return response;
    })["catch"](function (error) {
      return error;
    });
  } else {
    // handle regular non iOS 13+ devices
    return Promise.resolve('granted');
  }
}
/**
 * Requests device motion permission for iOS 13+
 * returns a promise that responds with the permission state
 * or false if the device is non iOS 13+
 * NOTE: this is required for the devicemotion event to work on iOS 13+
 * AND must be called from a user-driven event like a button click
 */


function requestDeviceMotionPermission() {
  // eslint-disable-next-line
  if (!window.DeviceMotionEvent) return Promise.resolve('granted'); // eslint-disable-next-line

  if (isMobileDevice() && typeof DeviceMotionEvent.requestPermission === 'function') {
    // eslint-disable-next-line
    return DeviceMotionEvent.requestPermission().then(function (response) {
      return response;
    })["catch"](function (error) {
      return error;
    });
  } else {
    // handle regular non iOS 13+ devices
    return Promise.resolve('granted');
  }
}

export { isChromeiOS, isIPad, isMobileDevice, isWebGL2Supported, isWebGLSupported, isiOS, requestDeviceMotionPermission, requestDeviceOrientationPermission, trimProjectName };